module.exports = __webpack_public_path__ + "img/minotaur_horn.92ce2872.png";